// extracted by mini-css-extract-plugin
export default {"info":"ConfirmMarketingPreferencesPopup__info--36H","infoPanel":"ConfirmMarketingPreferencesPopup__infoPanel--3es","inner":"ConfirmMarketingPreferencesPopup__inner--1Ix"};